module.exports = __webpack_public_path__ + "img/lunette.4df073f0.jpg";